import type { ReactNode } from "react";

import { cx } from "../lib/cx";

export interface CardProps {
  children: ReactNode;
  className?: string;
  padded?: boolean;
}

export function Card({ children, className, padded = true }: CardProps) {
  return (
    <section
      className={cx(
        "rounded-card bg-surface text-text shadow-clay transition-colors",
        padded && "p-6",
        className,
      )}
    >
      {children}
    </section>
  );
}
